const KEY = "hexxium_recently_viewed";
const MAX = 10;

export const recordView = (p) => {
  if (!p?.id) return;
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]").filter((x) => x && x.id !== p.id);
    const variants = (p.variants || []).filter((v) => v.active !== false);
    list.unshift({
      id: p.id,
      name: p.name,
      image: p.image_url || p.image || "",
      category: p.category || "",
      price: p.price,
      sale_price: p.sale_price,
      sale_ends_at: p.sale_ends_at,
      has_variants: !!(p.has_variants || variants.length),
      starting_price: p.starting_price ?? (variants.length ? Math.min(...variants.map((v) => v.price)) : undefined),
      at: Date.now(),
    });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* storage unavailable — ignore */
  }
};

export const getRecentlyViewed = (excludeIds = []) => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]").filter((p) => p && p.id && !excludeIds.includes(p.id));
  } catch {
    return [];
  }
};
